import { Table } from 'antd';
import { type FC } from 'react';

import {
  EmptyComponentWithDataTestId,
  Error403Unauthorized,
} from '@app/components';
import { generateSpanWithDataTestId } from '@app/shared/utils';
import type { NClientServices } from '@app/types';
import { getPaginationItemRenderWithDataTestIds } from '@app/utils';

import {
  useServiceCategories,
  useServiceCategoriesEffects,
} from '@pages/ServiceCategories/hooks';

import '@pages/ServiceCategories/styles/ServiceCategories.mobile.scss';

export const ServiceCategories: FC = () => {
  const {
    isLoading,
    categories,
    isMobile,
    handleChange,
    hasUserRightForModuleView,
    hasUserRightToRegister,
    pagination,
    getClientServiceCategoriesHandler,
    columns,
  } = useServiceCategories();

  useServiceCategoriesEffects({ getClientServiceCategoriesHandler });

  if (!hasUserRightForModuleView || !hasUserRightToRegister) {
    return <Error403Unauthorized />;
  }

  return (
    <div className="ServiceCategories">
      <Table<NClientServices.Category>
        loading={isLoading}
        columns={columns}
        className="ServiceCategories__table"
        locale={{ emptyText: <EmptyComponentWithDataTestId /> }}
        dataSource={categories}
        rowClassName="service-item"
        rowKey={({ Id }) => Id}
        size={isMobile ? 'small' : 'middle'}
        scroll={{ x: 600 }}
        pagination={{
          itemRender: getPaginationItemRenderWithDataTestIds,
          size: isMobile ? 'small' : 'default',
          showSizeChanger: true,
          showLessItems: isMobile,
          position: isMobile ? ['bottomCenter'] : ['bottomLeft'],
          showTotal: (total, range) =>
            generateSpanWithDataTestId(
              isMobile
                ? `Всего ${total}`
                : `Показаны ${range[0]}-${range[1]} из ${total}`,
              'pagination-info'
            ),
          ...pagination,
          onChange: handleChange,
        }}
      />
    </div>
  );
};
